// Determines the correct API base URL.
// - In production custom domain (bluevault.me / emergent.host): use same origin
// - Otherwise (preview/local dev): use REACT_APP_BACKEND_URL
function resolveApiBase() {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const prodHosts = ['bluevault.me', 'www.bluevault.me'];
    const isEmergentHost = host.endsWith('.emergent.host');
    if (prodHosts.includes(host) || isEmergentHost) {
      return `${window.location.origin}/api`;
    }
  }
  return `${process.env.REACT_APP_BACKEND_URL}/api`;
}

export const API = resolveApiBase();
